import * as Icons from "lucide-react";

export function DynIcon({ name, ...props }) {
  const Cmp = Icons[name] || Icons.Scale;
  return <Cmp {...props} />;
}
